var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.357 12.333l.438-3.377h-3.36V6.799c0-.978.272-1.644 1.681-1.644h1.797V2.132A24.175 24.175 0 0014.295 2C11.705 2 9.93 3.574 9.93 6.465v2.49H7v3.378h2.93V21h3.505v-8.667h2.922z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNiAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjM1NzIgMTIuMzMzM0wxNi43OTQ3IDguOTU1NzFIMTMuNDM0NVY2Ljc5OTIxQzEzLjQzNDUgNS44MjEyOCAxMy43MDczIDUuMTU0OTUgMTUuMTE2MiA1LjE1NDk1TDE2LjkxMyA1LjE1NDE5VjIuMTMzQzE2LjYwMjMgMi4wOTE5NiAxNS41MzU2IDIgMTQuMjk0NiAyQzExLjcwNDEgMiA5LjkzMDE0IDMuNTczOTYgOS45MzAxNCA2LjQ2NDgxVjguOTU1NzFIN1YxMi4zMzMzSDkuOTMwMTRWMjFIMTMuNDM0NVYxMi4zMzMzSDE2LjM1NzJaIiBmaWxsPSJjdXJyZW50Y29sb3IiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };